module.exports = __webpack_public_path__ + "img/platforminfo_2.a930b133.png";